import { render, staticRenderFns } from "./hero-content.vue?vue&type=template&id=1f4f3e42&scoped=true"
import script from "./hero-content.vue?vue&type=script&lang=js"
export * from "./hero-content.vue?vue&type=script&lang=js"
import style0 from "./hero-content.vue?vue&type=style&index=0&id=1f4f3e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4f3e42",
  null
  
)

export default component.exports